import React from "react";
import { useWatchState } from "@/store";
import { Modal } from "antd";
import "./style.less";

const App = () => {

    const [[{ title, show, hide, width = 600, html, className }]] = useWatchState(["modal.html"])

    return (
        <Modal
            className={className}
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
        >
            <div dangerouslySetInnerHTML={{ __html: html }}></div>
        </Modal>
    );
}

export default App;